import AjaxRequest from "../modules/ajax-request";
import Cookies from 'js-cookie';

class HeaderUserControls {
    constructor(element) {
        this.div = element;
        this.loggedContentUrl = "";
        this.logoutUrl = "";
        this.contentId = ""
        this.getData();
        this.clearData();
        this.bindEvents();
    }

    getData() {
        this.loggedContentUrl = this.div.getAttribute("data-render-logged-content-url") || '';
        this.logoutUrl = this.div.getAttribute("data-do-logout-url") || '';
        this.logoutId = '[data-id="header-user-controls__logout"]';
        this.contentId = '[data-id="header-user-controls"]';
    }

    clearData() {
        this.div.removeAttribute("data-render-logged-content-url");
        this.div.removeAttribute("data-do-logout-url");
    }

    bindEvents() {
        let _this = this;

        document.addEventListener('user_not_logged', function () {
            let _divNotLoggedContent = document.querySelectorAll(_this.contentId);
            _divNotLoggedContent.forEach(function (el) {
                el.style.display = '';
            });
        });

        document.addEventListener('user_logged', function () {
            _this.renderLoggedContent();
        });
    }

    bindRenderLoggedContentEvents(contentNodes) {
        let _this = this;

        // El header renderiza este partial dos veces (barra + drawer, ver render.html.twig),
        // así que hay que enganchar el botón de "Cerrar sesión" en cada copia, no solo en
        // la primera: cuál de las dos está visible depende del breakpoint (ver _components.header.scss
        // y _components.drawer.scss), y ambas deben quedar funcionales.
        contentNodes.forEach(function (contentNode) {
            let logoutButton = contentNode.querySelector(_this.logoutId);
            if (logoutButton) {
                logoutButton.addEventListener("click", function (event) {
                    event.preventDefault();
                    _this.doLogout();
                });
            }
        });
    }

    doLogout() {
        let _ajaxRequest = new AjaxRequest({
            successCallback: function () {
                Cookies.remove("cs_logged");
                Cookies.remove("cs_adv");
                location.reload();
            }
        });
        _ajaxRequest.makeCall(this.logoutUrl);
    }

    renderLoggedContent() {
        let contentNodes = document.querySelectorAll(this.contentId);
        if (contentNodes.length > 0) {
            let _this = this;
            let _ajaxRequest = new AjaxRequest({
                successCallback: function (response) {
                    contentNodes.forEach(function (el) {
                        el.innerHTML = response.message;
                        el.style.display = '';
                    });
                    _this.bindRenderLoggedContentEvents(contentNodes);
                    document.body.classList.add('is-logged');
                }
            });
            _ajaxRequest.makeCall(this.loggedContentUrl);
        }
    }
}

export default HeaderUserControls;